import { Chip, Typography } from '@mui/material';
import {
  PhysicianDocument,
  DocumentSignatureCompositeStatuses,
  compositeWorkflowStatusFromDocument,
} from 'src/services/apiServices/physician-service/physician-service';

type StatusChipProps = {
  document: PhysicianDocument;
  isSignedExternally?: boolean;
};

export const StatusChip = ({ document, isSignedExternally }: StatusChipProps) => {
  const compositeStatus = isSignedExternally
    ? 'SIGNED'
    : compositeWorkflowStatusFromDocument(document);
  const getChipStyles = (status: DocumentSignatureCompositeStatuses) => {
    const styles = {
      '': {
        color: '#6C737F',
        backgroundColor: 'rgba(17, 25, 39, 0.08)',
      },
      'AWAITING SIGNATURE': {
        color: '#6C737F',
        backgroundColor: 'rgba(17, 25, 39, 0.08)',
      },
      UPCOMING: {
        color: '#6366F1',
        backgroundColor: '#EBEEFE',
      },
      URGENT: {
        color: '#B54708',
        backgroundColor: '#F790091F',
      },
      OVERDUE: {
        color: '#B42318',
        backgroundColor: '#F044381F',
      },
      PENDING_APPROVAL: {
        color: '#DA691E',
        backgroundColor: '#FFE5D4',
      },
      APPROVED: {
        color: '#DA691E',
        backgroundColor: '#FFE5D4',
      },
      SIGNED: {
        color: '#15B79E',
        backgroundColor: '#E5F9F6',
      },
      COMPLETED: {
        color: '#15B79E',
        backgroundColor: '#E5F9F6',
      },
    };
    return styles[status] || {};
  };

  return compositeStatus ? (
    <Chip
      label={<Typography variant="overline">{compositeStatus}</Typography>}
      variant="outlined"
      sx={{
        marginLeft: '10px',
        ...getChipStyles(compositeStatus),
      }}
    />
  ) : (
    <>-</>
  );
};
